module.exports = __webpack_public_path__ + "static/media/assistance.5e26eeae.svg";